import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import {getGlobalLink} from '../../../utils/contentstack-utils'

/**
 * Group title followed by its category links. Shared by every menu/drawer template so
 * the group link markup and styling come from a single place.
 * `styles` is the MenuTemplate multi-style config of the calling template; any extra
 * props are applied to the group container.
 */
const CategoryLinkGroup = ({group, categoryData, locale, styles, ...containerProps}) => {
    const linkButtonStyles = styles?.groupLinkButton ?? {}
    const baseButtonProps = {
        ...linkButtonStyles,
        size: 'base',
        // Button sizes set their own textStyle, so it has to be enforced via sx
        sx: {textStyle: linkButtonStyles.textStyle},
    }

    return (
        <Flex {...containerProps}>
            <Text {...styles?.titleContainer}>{group?.group_title}</Text>

            {group?.redirect?.map((red, idx) => {
                const {label, url, isAbsolute} =
                    getGlobalLink({
                        link: red,
                        categoriesData: categoryData,
                        locale: locale?.alias,
                    }) || {}

                const key = `${group?.group_title}-${label}-${idx}`
                const buttonProps = {...baseButtonProps, cursor: url ? 'pointer' : 'default'}

                return isAbsolute ? (
                    <Button
                        key={key}
                        {...buttonProps}
                        as="a"
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {label}
                    </Button>
                ) : (
                    <Button key={key} {...buttonProps} as={RouteLink} to={url}>
                        {label}
                    </Button>
                )
            })}
        </Flex>
    )
}

CategoryLinkGroup.propTypes = {
    group: PropTypes.shape({
        uid: PropTypes.string,
        group_title: PropTypes.string,
        redirect: PropTypes.array,
    }),
    categoryData: PropTypes.object,
    locale: PropTypes.shape({
        alias: PropTypes.string,
    }),
    styles: PropTypes.object,
}

export default CategoryLinkGroup
